(function () {
  angular.module("akitabox.ui.directives.attachmentUpload", [
    "akitabox.core.constants",
    "akitabox.core.toast",
    "akitabox.core.services.document",
  ]);
})();
